export default __webpack_public_path__ + "static/media/gh.7d9a6bec.svg";